import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Chat.css";
import GPTIcon from "../../assets/images/gptIcon2.png";
import profileIcon from "../../assets/images/profileNew.png";
import backgroundImage from "../../assets/images/chatBackground.png";
import techMaterial from "../../assets/images/tech.png";
import formulation from "../../assets/images/for.png";
import source from "../../assets/images/sou.png";
import { Box, TextField, IconButton, InputAdornment } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import { Typography } from "@mui/material";
import logo from "../../assets/images/dashboardLogo.png";
// import { env } from "../../environment";
import { useEventEmitter } from "../../contexts/EventEmmiter";
import HeaderProfile from "../../components/profile/ProfileHeader";
import { encrypted } from "../../utils/Utility";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchVerifyToken } from "../../store/apiActions";
import { env } from "../../environment.template";

function Chat() {
  const [message, setMessage] = useState("");
  const [attachedFile, setAttachedFile] = useState(null);
  const [messages, setMessages] = useState([]);
  const [renderedMessage, setRenderedMessage] = useState("");
  const [cardClicked, setCardClicked] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [botInfo, setBotInfo] = useState([]);

  const handleAttachFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAttachedFile(file);
      setMessage((prevMessage) => prevMessage + `${file.name}`);
    }
  };
  const handleSendMessage = async () => {
    if(message.length >= 400){
      toast.error("Message should not be more than 400 characters");
    }
    if (message.trim() && message.length <= 400 || attachedFile) {
      // Add user's message immediately
      const userMessage = { sender: "user", text: message };
      setMessages((prevMessages) => [userMessage, ...prevMessages]);

      // Add placeholder bot message immediately to show that the bot is typing...
      const placeholderBotMessage = {
        sender: "bot",
        text: "Loading...",
      };
      setMessages((prevMessages) => [
        userMessage,
        placeholderBotMessage,
        ...prevMessages,
      ]);

      // Clear the message input field and the attached file
      setMessage("");
      setAttachedFile(null);
      // fetchData();
      const token = localStorage.getItem("token");
      try {
        // Fetch bot's response
        const response = await fetch(`${env.baseURL}/query`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            encryptedBody: encrypted.encrypt(
              JSON.stringify({ query: message })
            ),
          }),
        });
        const data1 = await response.json();
        const data = JSON.parse(encrypted.decrypt(data1.encryptedBody));
        const botResponseText = data?.responses[0]?.response || "No response.";
        // Create the bot's actual message
        const botMessage = {
          sender: "bot",
          text: "",
          metadata: data?.responses[0]?.metadata[0],
        };
        setBotInfo(data?.responses[0]?.metadata[0]);
        // Function to update bot's message character by character
        const typeMessageCharacterByCharacter = (message, index = 0) => {
          if (index < message.length) {
            botMessage.text = botMessage.text + message[index];
            setMessages((prevMessages) => {
              const newMessages = [...prevMessages];
              newMessages[1] = {
                ...newMessages[1],
                text: botMessage.text,
                metadata: data?.responses[0]?.metadata[0],
              }; // Update bot message
              return newMessages;
            });
            setTimeout(
              () => typeMessageCharacterByCharacter(message, index + 1),
              5
            );
          }
        };
        // Start typing the bot message character by character
        typeMessageCharacterByCharacter(botResponseText);
      } catch (error) {
        // Handle errors and add error message from bot
        const errorMessage = {
          sender: "bot",
          text: "Sorry, I'm having trouble understanding that.",
        };

        // Replace the placeholder bot message with the error message
        setMessages((prevMessages) => {
          const newMessages = [...prevMessages];
          newMessages[1] = errorMessage; // Replace the placeholder bot message
          return newMessages;
        });
      }
    }
  };

  const dispatch = useDispatch();
  const countryResponse = useSelector(
    (state) => state?.api?.verifyTokenDetails
  );
  useEffect(() => {
    dispatch(fetchVerifyToken(`${env.baseURL}/auth/azure/verify-token`));
  }, []);

  useEffect(() => {
    if (countryResponse?.data?.encryptedBody) {
      let item = JSON.parse(
        encrypted.decrypt(countryResponse?.data?.encryptedBody)
      );
      if (item.message == "Token invalid") {
        handleLogout();
      }
    }
  }, [countryResponse]);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token"); // Retrieve token
      const response = await fetch(`${env.baseURL}/app-users/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Include auth token
        },
      });
      if (response.ok) {
        toast.success("Logout successful!");
      } else {
        toast.success("Logout successful!");
      }
    } catch (error) {
      toast.success("Logout successful!");
    }

    // Clear local storage and redirect
    localStorage.clear();
    window.location.href = "/sign-in";
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevents form submission
      handleSendMessage();
    }
  };

  // Update messages with renderedMessage
  useEffect(() => {
    if (
      renderedMessage &&
      messages.length > 0 &&
      messages[messages.length - 1].sender === "bot"
    ) {
      const updatedMessages = [...messages];
      updatedMessages[0] = { sender: "bot", text: renderedMessage }; // Update the last bot message
      setMessages(updatedMessages);
    }
  }, [renderedMessage, messages]);

  const handleCardClick = (text) => {
    setMessage(text); // Set the message field to the selected text
    setCardClicked(true); // Indicate that a card was clicked
  };

  // Trigger handleSendMessage when cardClicked is true
  useEffect(() => {
    if (cardClicked) {
      handleSendMessage();
      setCardClicked(false); // Reset the click state
    }
  }, [cardClicked]);

  const [isSidebarMinimized, setIsSidebarMinimized] = useState(() => {
    const saved = localStorage.getItem("sidebarMinimized");
    return saved == "true"; // Return true if saved state is 'true'
  });

  const handleToggleMinimize = (isMinimized) => {
    setIsSidebarMinimized(isMinimized);
  };

  useEffect(() => {
    // Get the user details from localStorage
    const userDetails = localStorage.getItem("LoggedInDetails");

    if (userDetails) {
      try {
        // Parse the JSON string
        const user = JSON.parse(userDetails);
        // Split the full_name field and extract the first name
        const nameParts = user.full_name.split("/");
        const firstName = nameParts[0]?.split(" ")[0]; // Get the first name
        setFirstName(firstName);
      } catch (error) {
        console.error("Error parsing user details from localStorage", error);
      }
    }
  }, []);

  useEffect(() => {
    // Load chat history on component mount
    const savedChatHistory = localStorage.getItem("chatHistory");
    if (savedChatHistory) {
      setMessages(JSON.parse(savedChatHistory));
    }
  }, []);

  useEffect(() => {
    // Save chat history whenever messages change
    localStorage.setItem("chatHistory", JSON.stringify(messages));
  }, [messages]);

  const { subscribe } = useEventEmitter(); 

  useEffect(() => {
    // Subscribe to the 'resetChild' event
    const unsubscribe = subscribe("resetChild", (data) => {
      setMessages([]);
      localStorage.removeItem("chatHistory");
    });

    // Cleanup the subscription on unmount
    return () => unsubscribe();
  }, [subscribe]);

  const chatEndRef = useRef(null);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    // Trigger scroll after messages are rendered
    scrollToBottom();
  }, [messages]);
  const loggedInDetails = localStorage.getItem("LoggedInDetails");
  return (
    <>
      <ToastContainer closeButton={false} position="top-right" />
      <div
        className="chat-container"
        style={{
          display: "grid",
          gridTemplateColumns: isSidebarMinimized ? "6% 92%" : "20% 80%",
        }}
      >
        <Sidebar onToggleMinimize={handleToggleMinimize} />
        <div
          style={{
            height: "95%",
            overflowY: "hiden",
            padding: "5px",
            marginRight: "2%",
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            gridTemplateRows: "20vh 76vh",
          }}
        >
          <div>
            <div className="header-container-chat">
              <HeaderProfile loggedInDetails={loggedInDetails} />
            </div>
            <div className="chatbot-logo">
              <img src={logo} alt="" />
            </div>
          </div>
          <div
            style={{
              height: "100%",
              display: "grid",
              gridTemplateRows: "8% 7% 85%",
            }}
          >
            <Typography
              variant="h5"
              color="#121417"
              fontSize={25}
              margin={0}
              marginBottom={2}
              fontWeight={600}
              gutterBottom
            >
              <span className="back-chat-title">
                Hey {firstName}! What can I help you with?
              </span>
            </Typography>
            <div className="search-container">
              <div className="card-container">
                <div
                  className="card-item"
                  // onClick={() => handleCardClick("Technical Material")}
                >
                  <img height="25px" src={techMaterial} alt="" />
                  Technical Material
                </div>
                <div
                  className="card-item"
                  // onClick={() => handleCardClick("Formulation")}
                >
                  <img height="25px" src={formulation} alt="" />
                  Formulation
                </div>
                <div
                  className="card-item"
                  // onClick={() => handleCardClick("Source of Technical")}
                >
                  <img height="25px" src={source} alt="" />
                  Source of Technical
                </div>
              </div>
            </div>
            <div className="chat-history-container">
              <div className="chat-header-container">
                <div className="chat-box">
                  {messages
                    .slice()
                    .reverse()
                    .reduce(
                      (
                        groupedMessages,
                        currentMessage,
                        index,
                        reversedArray
                      ) => {
                        if (
                          currentMessage.sender === "bot" &&
                          reversedArray[index + 1]?.sender === "user"
                        ) {
                          groupedMessages.push({
                            userMessage: reversedArray[index + 1],
                            botMessage: currentMessage,
                          });
                        }
                        return groupedMessages;
                      },
                      []
                    )
                    .map((pair, index) => (
                      <div key={index} className="message-pair-container">
                        {/* User Message */}
                        {pair.userMessage && (
                          <div className="message-container user-message">
                            <div className="message-content">
                              {pair.userMessage.text}
                            </div>
                            <div className="chat-history-icon">
                              <img
                                height={"30px"}
                                width={"30px"}
                                src={profileIcon}
                                alt=""
                              />
                            </div>
                          </div>
                        )}
                        {/* Bot Message */}
                        {pair.botMessage && (
                          <div className="message-container bot-message">
                            <div className="chat-history-icon">
                              <img src={GPTIcon} alt="" />
                            </div>
                            <div className="message-content">
                              <div>{pair.botMessage.text}</div>
                              <div
                                style={{
                                  borderBottom: "1px solid #696868",
                                  margin: "10px 0px",
                                }}
                              ></div>
                              <div style={{ fontWeight: "bold" }}>
                                {"Ref: " +
                                  // "JRF Study Number: " +
                                  (pair?.botMessage?.metadata?.study_number ||
                                    "--") +
                                  ", " +
                                  // "Study Title: " +
                                  (pair?.botMessage?.metadata?.study_title ||
                                    "--") +
                                  ", " +
                                  // "File: " +
                                  (pair?.botMessage?.metadata
                                    ?.enclosure_number || "--")}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  <div ref={chatEndRef}></div>
                </div>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ddd",
                    borderRadius: "25px",
                    padding: "0px 10px !important",
                    backgroundColor: "#f9f9f9",
                    width: "70%",
                  }}
                >
                  <IconButton
                    component="label"
                    edge="start"
                    sx={{ cursor: "not-allowed", color: "#999" }}
                  >
                    <AttachFileIcon />
                    <input
                      type="file"
                      disabled
                      hidden
                      autoComplete="off"
                      onChange={handleAttachFile}
                    />
                  </IconButton>
                  <TextField
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyPress={handleKeyPress}
                    variant="outlined"
                    placeholder="Type your question here..."
                    autoComplete="off"
                    sx={{
                      flex: 1,
                      "& .MuiOutlinedInput-root": {
                        border: "none",
                        padding: "4px 0 5px !important",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "0px !important",
                        fontSize: "14px",
                        border: "none",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleSendMessage}>
                            <SendIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </div>
            </div>
            {/* <Footer /> */}
            <div className="copyright-label">
              © 2025DossierGenAI. All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Chat;
